import { render } from "./who_to_follow_panel.vue?vue&type=template&id=7b8e2922"
import script from "./who_to_follow_panel.js?vue&type=script&lang=js"
export * from "./who_to_follow_panel.js?vue&type=script&lang=js"

import "./who_to_follow_panel.vue?vue&type=style&index=0&id=7b8e2922&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__